export const authRoles = {
  sa: ['sa'], // Only Super Admin has access
  admin: ['sa', 'admin'], // Only SA & Admin has access
};
